import { InvoiceItem } from "../../../GeneratedClients/FreeBillApi";

class ItemCalculator{
  item
  constructor(item: InvoiceItem){
    this.item = item
  }

  getGrossAmount() {
    return this.calculateGrossAmountForItem(this.item)
  }

  getNetAmount() {
    return this.calculateNetAmountForItem(this.item)
  }

  getTaxAmount() {
    return this.calculateTaxAmountForItem(this.item)
  }

  private calculateNetAmountForItem = (item: InvoiceItem) => {
    const discount = item.discount_in_percent ? item.discount_in_percent : 0
    const netAmount = item.price && item.quantity ? item.price * item.quantity : 0
    const result = netAmount - (netAmount * discount)
    return Math.round((result + Number.EPSILON) * 100) / 100
  }

  private calculateTaxAmountForItem = (item: any) => {
    const netAmount = this.calculateNetAmountForItem(item)
    const result = item.tax_in_percent ? item.tax_in_percent * netAmount : 0
    return Math.round((result + Number.EPSILON) * 100) / 100
  }

  private calculateGrossAmountForItem = (item: InvoiceItem) => {
    const netAmount = this.calculateNetAmountForItem(item)
    const tax = this.calculateTaxAmountForItem(item)
    return netAmount + tax
  }
}

export default ItemCalculator